var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { EntityValidationsService } from "../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { GenesisRouterConstants } from "../../../configuration/router.constants";
import { getFailureReason, requiresSignInAgain, translateFailure } from "./two-factor-messages";
var TwoFactor = /** @class */ (function () {
    function TwoFactor(tokenClient, notificationClientService, entityValidationsService, router, i18N) {
        this.tokenClient = tokenClient;
        this.notificationClientService = notificationClientService;
        this.entityValidationsService = entityValidationsService;
        this.router = router;
        this.i18N = i18N;
        this.emailMode = false;
        this.allowEmailFallback = false;
        this.messageNotificationString = null;
    }
    TwoFactor.prototype.activate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.tokenClient.getTwoFactorOptions()];
                    case 1:
                        options = _a.sent();
                        this.allowEmailFallback = !!options && options.allowEmailFallback;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.handleFailure(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TwoFactor.prototype.attached = function () {
        var rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "TwoFactor",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                    errorMessage: this.i18N.tr('two-factor-code-required-text'),
                    parameters: null, property: "code",
                    validationType: ValidationTypeEnum.Required
                }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    };
    TwoFactor.prototype.signin = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Login);
    };
    TwoFactor.prototype.sendEmailCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.messageNotificationString = null;
                        this.sendingEmail = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.tokenClient.sendTwoFactorEmailCode()];
                    case 2:
                        _a.sent();
                        this.emailMode = true;
                        this.code = null;
                        this.notificationClientService.show(this.i18N.tr('two-factor-title-text'), this.i18N.tr('two-factor-email-sent-text'), NotificationType.Success, 3000);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        this.handleFailure(error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.sendingEmail = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TwoFactor.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResponse, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.messageNotificationString = null;
                        this.submitting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        return [4 /*yield*/, this.validator.validate()];
                    case 2:
                        validationResponse = _a.sent();
                        if (!validationResponse.valid) {
                            return [2 /*return*/];
                        }
                        if (!this.emailMode) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.tokenClient.validateTwoFactorEmailCode(this.code)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.tokenClient.validateTwoFactorCode(this.code)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        // the auth cookie only exists now, so boot the admin shell from the root url
                        window.location.href = "/";
                        return [3 /*break*/, 9];
                    case 7:
                        error_3 = _a.sent();
                        this.handleFailure(error_3);
                        return [3 /*break*/, 9];
                    case 8:
                        this.submitting = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    TwoFactor.prototype.handleFailure = function (error) {
        var _this = this;
        var message = translateFailure(this.i18N, error);
        this.messageNotificationString = message;
        this.notificationClientService.show(this.i18N.tr('two-factor-title-text'), message, NotificationType.Error);
        if (requiresSignInAgain(getFailureReason(error))) {
            setTimeout(function () { return _this.signin(); });
        }
    };
    TwoFactor = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient,
            NotificationClientService,
            EntityValidationsService,
            Router,
            I18N])
    ], TwoFactor);
    return TwoFactor;
}());
export { TwoFactor };
